import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PeriodData, PeriodParams } from '../resolvers/period.resolver';
import { getChildRoute, TypedActivatedRouteSnapshot } from '../utils/route-utils';
import { HealthService } from './health.service';

@Injectable({ providedIn: 'root' })
export class LayoutService implements OnDestroy {
  demoRegisterCreated = new Subject<void>();
  isDemo = new Subject<boolean>();
  showOutage = new Subject<boolean>();
  showCalendarSelector = new Subject<boolean>();
  showPaymentRequired = new Subject<boolean>();
  showRegimeSelector = new Subject<boolean>();
  refreshNav = new Subject<void>();

  private hasOutage = false;

  private subscription = this.router.events
    .pipe(filter((e: any): e is NavigationEnd => e instanceof NavigationEnd))
    .subscribe(() => {
      if (this.hasOutage) {
        this.checkForOutage();
      }

      const { register } = getChildRoute(
        this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
          PeriodParams,
          PeriodData
        >,
      ).data;

      this.isDemo.next(register?.isDemo ?? false);
    });

  constructor(
    private healthService: HealthService,
    private router: Router,
  ) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // checkForAuthOutage() {
  //   this.healthService.healthCheckAuth().subscribe(
  //     result => {
  //       this.showOutage.next();
  //       this.hasOutage = false;
  //     },
  //     error => {
  //       this.hasOutage = true;
  //       this.showOutage.next(true);
  //     },
  //   );
  // }

  checkForOutage() {
    this.healthService.healthCheck().subscribe({
      next: result => {
        this.hasOutage = false;
        this.showOutage.next(result !== 'Healthy');
      },
      error: error => {
        this.hasOutage = true;
        this.showOutage.next(true);
      },
    });
  }

  setDemoRegisterCreated() {
    this.demoRegisterCreated.next();
  }

  setPaymentRequired(paymentRequired: boolean = true) {
    this.showPaymentRequired.next(paymentRequired);
  }

  setShowCalendarSelector(show: boolean = true) {
    this.showCalendarSelector.next(show);
  }

  setShowRegimeSelector(show: boolean = true) {
    this.showRegimeSelector.next(show);
  }

  triggerNavRefresh() {
    this.refreshNav.next();
  }
}
